import get from 'lodash/get';
import { getOnlineOrderingUrlParams } from 'utils/url';

import { setupInitialData } from 'base/actions/setupInitialData';
import handleSingleLocationFlow from 'base/actions/handleSingleLocationFlow';

/*
  This thunk is dispatched at the beginning of app render.
  We setup initial data (cart, locations, account, user), then, if there is more than 1
  location in the response and the requested route is root or /location-slug,
  fire handleSingleLocation flow which will navigate the user to menu page or order settings page
*/

export const setupInitialFlow = () => async (dispatch, getState) => {
  const { router } = getState();
  const { isRoot, locationSlug, isLocationPage } = getOnlineOrderingUrlParams(
    router.location.pathname
  );

  const result = await dispatch(setupInitialData({ locationSlug }));
  const locations = get(result, 'payload.locations', []);
  const isSingleLocation = locations.length === 1;
  if (isSingleLocation && (isRoot || isLocationPage)) {
    await dispatch(handleSingleLocationFlow(result.payload.cart));
  }
};
